import logo from "./logo.svg";
import "./App.css";
import Navbar from "./components/navbar/Navbar";
import "./style.css";
import Home from "./components/home/Home";
import Primary from "./components/cards/Primary";
import Service from "./components/services/Service";
import Contact from "./components/contact/Contact";
import Footer from "./components/footer/Footer";
import Calendar from "./components/minute-components/forms/Calendar";
import Checkbox from "./components/minute-components/forms/checkbox/Checkbox";
import Dropdown from "./components/minute-components/forms/dropdown/Dropdown";
import Input from "./components/minute-components/forms/input/Input";
import File from "./components/minute-components/forms/input/File";
import Email from "./components/minute-components/forms/input/Email";
import PrimaryButton from "./components/minute-components/forms/buttons/PrimaryButton";
import SecondaryButton from "./components/minute-components/forms/buttons/SecondaryButton";
import Image from "./components/minute-components/image/Image";
import Accordian from "./components/minute-components/accordians/Accordian";
import Carousel from "./components/minute-components/carousel/Carousel";
import Cards from "./components/cards/Cards";
import PrimaryHead from "./components/headings/PrimaryHead";
import SecondaryHead from "./components/headings/SecondaryHead";
import Project from "./components/projects/Project";
function App() {
  return (
    <div className="App">
      {/* -------------------Navbars------------------- */}

      <Navbar type="primary" url={"https://i.ibb.co/mDpBP1s/logo-evolve.png"} />


      {/* -------------------Home Page------------------- */}

      <Home
        company_name={"Narayan Soni"}
        about_company={
          "I am a computer science and engineering undergraduate with deep expertise in the field of web development. I am also a web development lead at GDSC & CDL at GCP"
        }
      />

      {/* -------------------Services------------------- */}

      <Service
        header={
          "I am more inclined towards the field of technology & loves to explore latest technological advancements"
        }
      />
      <div className="cards_services">
        <Cards
          type="primary"
          header={"GDSC"}
          body={
            "Web Development Team Lead: I have organised numerous sessions inclined towards the field of web development being as the lead of web development domain."
          }
        />
        <Cards
          type="secondary"
          header={"Apprentice"}
          body={
            "A free collection of USACO resources used by thousands of contestants every day. I was one of the students of USACO bronze summer classes 2022 with 100% Financial Aid."
          }
        />
          <Cards
            type="primary"
            header={"AWS Machine Learning Scholar"}
            body={
              "I'm sincerely honored to have been selected as the recipient of the AWS Machine Learning Scholarship 2021 (Foundation) offered by Udacity."
            }
          />
      </div>
      <Project/>
      {/* -------------------Contact------------------- */}
      <Contact company_name={"communication"} company_mail_id={"0201cse113@niet.co.in"} />

      {/* -------------------Footer------------------- */}

      <Footer
        email={"0201cse113@niet.co.in"}
        contact={"+919799085158"}
        linkedinlink={"https://www.linkedin.com/in/narayan-soni/"}
        githublink={"https://github.com/narayan954"}
        id="footer"
      />


    </div>
  );
}

export default App;
